import { render, staticRenderFns } from "./ParticipantsTeam.vue?vue&type=template&id=e80b2d5c&scoped=true&"
import script from "./ParticipantsTeam.vue?vue&type=script&lang=js&"
export * from "./ParticipantsTeam.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantsTeam.vue?vue&type=style&index=0&id=e80b2d5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80b2d5c",
  null
  
)

export default component.exports